import Text from '@/components/atoms/Text';
import * as S from './styles';
import ProdutoPaginaDesktopFallback from './fallback';
import { useServicoAssinaturaPageHookTypeReturn } from '../../hook/useServicoAssinaturaPageHook';
import Avatar from '@/components/atoms/Avatar';
import ListagemPlanosAssinatura from '@/components/organisms/ListagemPlanosAssinatura';

import PaginaVendaDesktopTemplate from '@/components/templates/PaginaVendaDesktopTemplate';
import Image from 'next/image';
import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';
import Accordion from '@/components/atoms/Accordion';
import AccordionItem from '@/components/molecules/AccordionItem';
import useMetodosUteis, {
  HTMLHigienizadoTag,
} from '@/hooks/useMetodosUteisHook';
import formatarHTML from '@/utils/formatarHTML';

export default function ServicoAssinaturaPaginaDesktop(
  props: useServicoAssinaturaPageHookTypeReturn,
) {
  const {
    assinatura,
    planoSelecionado,
    setPlanoSelecionado,
    adicionarProdutoASacola,
    // combosComOProduto,
    valorTotal,
    assinarAgora,
    // produtoRelacionados,
    planosAssinatura,
    // tipoAssinatura,
    // setTipoAssintura,
    assinaturaEmVigor,
    carregandoTitulosDisponiveisAssinatura,
    titulosDisponiveisAssinatura,
    bannerDestaqueAssinatura,
    iconeServicoAssinatura,
    gradienteReduzido,
    discosDisponiveis,
  } = props;

  const { higienizarHTML } = useMetodosUteis();

  if (!assinatura) return <ProdutoPaginaDesktopFallback />;

  return (
    <PaginaVendaDesktopTemplate
      $bannerDestaqueImagem={bannerDestaqueAssinatura}
      $breadcrumbPageTitle={assinatura?.nome ?? 'Assinatura'}
      $styleGradienteFundoBanner={{
        background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #111 100%)`,
        height: gradienteReduzido ? 20 : undefined,
      }}
      $styleGradienteDireitaBanner={{
        background: `linear-gradient(270deg, #111 0%, rgba(0, 0, 0, 0) 100%)`,
      }}
      $conteudoDescritivo={
        <S.ContainerInformativoStreaming>
          <Text
            $size={2}
            $color="neutral"
            $weight="medium"
            $align="left"
            $highContrast={false}
            $text={assinatura.descricao}
          />
          <S.ContainerPreviewCatalagoStreaming>
            {carregandoTitulosDisponiveisAssinatura
              ? Array.from({ length: 5 }).map((item, index) => (
                  <Skeleton
                    key={`${item}_${index}`}
                    style={{ width: 103, height: 153 }}
                  />
                ))
              : discosDisponiveis != null
                ? discosDisponiveis?.map((disco, index) => {
                    return (
                      <Image
                        key={'disco ' + index}
                        src={disco}
                        width={110}
                        height={110}
                        style={{
                          objectFit: 'cover',
                          // borderRadius: theme.radius[3],
                        }}
                        alt={`capa_disco_${assinatura.nome}_${index}`}
                        unoptimized
                      />
                    );
                  })
                : titulosDisponiveisAssinatura?.map((titulo, index) => {
                    const { urlx1, urlx2, urlx3 } = titulo.titulo.posterArquivo;
                    const posterArquivo = urlx3 || urlx2 || urlx1;
                    return (
                      <Image
                        key={titulo.tituloID}
                        src={posterArquivo}
                        width={103}
                        height={153}
                        style={{
                          objectFit: 'cover',
                          borderRadius: theme.radius[3],
                        }}
                        alt={`poster_${assinatura.nome}_${index}`}
                        unoptimized
                      />
                    );
                  })}
          </S.ContainerPreviewCatalagoStreaming>
          <div style={{ display: 'flex' }}>
            <Accordion $size={1} $style="solid">
              <AccordionItem
                $size={3}
                $variant="ghost"
                $disabled="off"
                $title="Como utilizar"
                $conteudo={
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <HTMLHigienizadoTag
                      html={higienizarHTML(
                        formatarHTML(
                          planosAssinatura?.[planoSelecionado]?.comoUtilizar ??
                            '',
                        ),
                      )}
                    />
                  </div>
                }
              />
            </Accordion>
          </div>
          {!!planosAssinatura?.[planoSelecionado]?.termosDeUso &&
          planosAssinatura?.[planoSelecionado]?.termosDeUso?.trim()?.length >
            1 ? (
            <div style={{ display: 'flex' }}>
              <Accordion $size={1} $style="solid">
                <AccordionItem
                  $size={3}
                  $variant="ghost"
                  $disabled="off"
                  $title="Termo de uso"
                  $conteudo={
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <HTMLHigienizadoTag
                        html={higienizarHTML(
                          formatarHTML(
                            planosAssinatura?.[planoSelecionado]?.termosDeUso ??
                              '',
                          ),
                        )}
                      />
                    </div>
                  }
                />
              </Accordion>
            </div>
          ) : null}
        </S.ContainerInformativoStreaming>
      }
      $conteudoCheckout={
        <S.ContainerInformacoesAssinatura>
          <S.ContainerEscolhaPlanos>
            <S.ContainerPlanosAssinaturaTexto>
              <Avatar
                $size={3}
                $shape="square"
                $variant="solid"
                $image={iconeServicoAssinatura}
                $color="neutral"
                $preencherFundo={false}
              />
              <Text
                $size={2}
                $color="neutral"
                $weight="medium"
                $align="left"
                $highContrast={true}
                $text="Escolha o plano:"
              />
            </S.ContainerPlanosAssinaturaTexto>
          </S.ContainerEscolhaPlanos>
          <ListagemPlanosAssinatura
            $cliquePlano={(index) => setPlanoSelecionado(index)}
            $planoSelecionado={planoSelecionado}
            $planosAssinaturas={planosAssinatura}
          />
        </S.ContainerInformacoesAssinatura>
      }
      $produtoJaFoiAssinado={assinaturaEmVigor}
      $valorTotal={valorTotal}
      $funcaoAdicionarAoCarrinho={adicionarProdutoASacola}
      $funcaoAcaoPrincial={assinarAgora}
      $textoBotaoAcaoPrincipal={
        assinaturaEmVigor ? 'Assinatura feita' : 'Assinar agora'
      }
    />
  );
}
